'use client'
import React, { useState } from 'react'
import MyImage from '../myImage'
import { BLUR_DATA_URL_BASE64 } from '@/shared/constants'
import useWindowSize from '@/shared/hooks/windowSize'
import CustomLink from '../customLink'
import { convertDt24h, dateCheck, getImgURL } from '@/shared/utils'
import articlePlaceholder from '@/assets/images/placeholder/articlePlaceholder.svg'

function FeaturedNews({ data }: any) {
  const [width] = useWindowSize()
  const [currentIndex, setCurrentIndex] = useState(0)

  const handleSlideChange = (newIndex: any) => {
    setCurrentIndex(newIndex)
  }

  const getSlideIndex = (e: any) => {
    const scrollPosition = e.target.scrollLeft
    const slideWidth = e.target.offsetWidth
    return Math.round(scrollPosition / slideWidth)
  }

  return (
    <>
      <div>
        {width && width < 993 ? (
          <>
            <div className='flex justify-between items-center'>
              <div className='my-4 text-[18px] font-extrabold'>Featured News</div>
              <div className='text-t-info'>
                {currentIndex + 1}/{data?.length}
              </div>
            </div>
            <div className='relative'>
              <div
                className='overflow-x-auto flex gap-4 snap-x snap-mandatory scroll-smooth'
                onScroll={(e) => handleSlideChange(getSlideIndex(e))}
              >
                {data?.map((news: any, i: number) => (
                  <div className='bg-widget cursor-pointer overflow-hidden rounded-lg shadow snap-start flex-shrink-0 w-full' key={i}>
                    <CustomLink href={`/${news?.oSeo?.sSlug}`} prefetch={false}>
                      <MyImage
                        src={news?.oImg?.sUrl ? getImgURL(news?.oImg?.sUrl) : ""}
                        placeholder='blur'
                        placeholderImage={articlePlaceholder}
                        alt={news?.oImg?.sText || news?.sSrtTitle}
                        blurDataURL={BLUR_DATA_URL_BASE64}
                        className='object-cover w-full aspect-video'
                        height={160}
                        width={256}
                        sizes='(max-width: 767px) 320px, (max-width: 991px) 360px, (max-width: 1190px) 400px, 600px'
                      />
                      <div className='p-2'>
                        <p className='overflow-hidden mx-4 my-2 font-bold leading-6 line-clamp-2'>{news?.sTitle}</p>
                        <div className='flex mx-4 flex-wrap items-center'>
                          <span className='text-primary-500 text-sm'>Cricket</span>
                          <span className='h-1.5 w-1.5 rounded-full bg-t-700 mx-2'></span>
                          <span className='text-sm text-t-info'>
                            {convertDt24h(dateCheck(news?.dPublishDisplayDate || news?.dPublishDate))}
                          </span>
                          <span className='h-1.5 w-1.5 rounded-full bg-t-700 mx-2'></span>
                          <span className='text-sm text-t-info'>{news?.nDuration} Min</span>
                        </div>
                      </div>
                    </CustomLink>
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className='my-3 text-[18px] font-extrabold'>Featured News</div>
            {data?.map((news: any, i: number) => (
              <div className='bg-widget rounded-lg my-5 cursor-pointer overflow-hidden' key={i}>
                <CustomLink href={`/${news?.oSeo?.sSlug}`} prefetch={false}>
                  <MyImage
                    src={news?.oImg?.sUrl ? getImgURL(news?.oImg?.sUrl) : ""}
                    alt={news?.oImg?.sText || news?.sSrtTitle}
                    placeholder='blur'
                    placeholderImage={articlePlaceholder}
                    blurDataURL={BLUR_DATA_URL_BASE64}
                    className='object-cover w-full aspect-video'
                    height={160}
                    width={256}
                    sizes='(max-width: 767px) 320px, (max-width: 991px) 360px, (max-width: 1190px) 400px, 600px'
                  />
                  <div className='p-4'>
                    <div className='flex items-center'>
                      <span className='text-primary-500'>Cricket</span>
                      <span className='text-sm text-t-info ml-2'>
                        {convertDt24h(dateCheck(news?.dPublishDisplayDate || news?.dPublishDate))}
                      </span>
                      <span className='h-1.5 w-1.5 rounded-full bg-t-700 mx-2'></span>
                      <span className='text-sm text-t-info'>{news?.nDuration} Min</span>
                    </div>
                    <div className='leading-6 text-[19px] mt-2 line-clamp-2'>{news?.sTitle}</div>
                  </div>
                </CustomLink>
              </div>
            ))}
          </>
        )}
      </div>
    </>
  )
}

export default FeaturedNews
